// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4366) return "static/css/4366.2.11.1.chunk.css";
	if (chunkId === 5630) return "static/css/5630.2.11.1.chunk.css";
	if (chunkId === 8738) return "static/css/8738.2.11.1.chunk.css";
	if (chunkId === 8576) return "static/css/8576.2.11.1.chunk.css";
	if (chunkId === 4716) return "static/css/4716.2.11.1.chunk.css";
	if (chunkId === 2131) return "static/css/2131.2.11.1.chunk.css";
	if (chunkId === 8916) return "static/css/8916.2.11.1.chunk.css";
	if (chunkId === 5231) return "static/css/5231.2.11.1.chunk.css";
	if (chunkId === 7376) return "static/css/7376.2.11.1.chunk.css";
	if (chunkId === 4456) return "static/css/4456.2.11.1.chunk.css";
	if (chunkId === 3716) return "static/css/3716.2.11.1.chunk.css";
	if (chunkId === 4136) return "static/css/4136.2.11.1.chunk.css";
	// return url for filenames based on template
	return undefined;
};